import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';

import { Loader } from '@crehana/ui';

import PusherProvider from '@crehana/web/dist/ReactContexts/PusherContext';

import { PusherTargetEnum } from 'Jsx/Types/Graphql/globals';
import { useCrehanaLiveTranslations } from 'Jsx/CrehanaLive/hooks';

import GET_LIVE from '../../graphql/GetLiveDetail.graphql';
import {
  GetLiveDetail,
  GetLiveDetailVariables,
} from '../../graphql/types/GetLiveDetail';
import LiveTabs from '../Detail/sections/LiveTabs';

const Chat = () => {
  const { t } = useCrehanaLiveTranslations();
  const reactRouterParams = useParams<{ liveSlug: string }>();
  const { data, loading } = useQuery<GetLiveDetail, GetLiveDetailVariables>(
    GET_LIVE,
    { variables: { slug: reactRouterParams.liveSlug } },
  );

  if (loading || !data || !data.live) {
    return (
      <div className="w-full h-screen flex flex-col items-center justify-center">
        <Loader white />
        <p className="block w-full mt-16 text-center text-white font-h4">
          {t('LOAD_CHAT')}
        </p>
        <p className="font-body3 mt-16 text-white">{t('WAIT_SECONDS')}</p>
      </div>
    );
  }

  const isActive = !!data.live.isLive;

  return (
    <PusherProvider target={PusherTargetEnum.LIVE} skip={!isActive}>
      <div className="h-screen flex flex-col">
        <LiveTabs
          live={data.live}
          isPoppedOut
          liveIsActive={isActive}
          chatIsActive={isActive}
          canSendMessages={isActive}
        />
      </div>
    </PusherProvider>
  );
};

export default Chat;
